export enum ErrorCode {
  ACCOUNT_CLOSED = 'ACCOUNT_CLOSED',
  ACCOUNT_CLOSED_PV = 'ACCOUNT_CLOSED_PV',
  APC_ON_DIFF_DEVICE = 'APC_ON_DIFF_DEVICE',
  BANNED_BY_REGULATOR = 'BANNED_BY_REGULATOR',
  BLOCKED_BY_GEO_IP = 'BLOCKED_BY_GEO_IP',
  CLIENT_TIMEOUT = 'CLIENT_TIMEOUT',
  CONNECTION_CLOSED = 'CONNECTION_CLOSED',
  EMAIL_NOT_ALLOWED = 'EMAIL_NOT_ALLOWED',
  ERR_COUNTRY_RESTRICTED = 'ERR_COUNTRY_RESTRICTED',
  ERR_LUGAS_REQUEST_FAILED = 'ERR_LUGAS_REQUEST_FAILED',
  ERR_USER_OWES_CHIPS = 'ERR_USER_OWES_CHIPS',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  LICENSE_MISMATCH = 'LICENSE_MISMATCH',
  LOGIN_COOL_OFF = 'LOGIN_COOL_OFF',
  LOGIN_MSG_NOT_ALLOWED = 'LOGIN_MSG_NOT_ALLOWED',
  MITID_AUTH_REQUIRED = 'MITID_AUTH_REQUIRED',
  NEMID_LOGIN_REQUIRED = 'NEMID_LOGIN_REQUIRED',
  NO_SUCH_USER = 'NO_SUCH_USER',
  NOT_ALLOWED_USER_ACTIVE = 'NOT_ALLOWED_USER_ACTIVE',
  PANIC_BUTTON_EXCLUDED = 'PANIC_BUTTON_EXCLUDED',
  PERMANENTLY_EXCLUDED = 'PERMANENTLY_EXCLUDED',
  PIN_INVALID = 'PIN_INVALID',
  PIN_REQUIRED = 'PIN_REQUIRED',
  POW_REQUIRED = 'POW_REQUIRED',
  PREVENT_LOGIN = 'PREVENT_LOGIN',
  RSA_INVALID_CREDENTIALS = 'RSA_INVALID_CREDENTIALS',
  RSA_REQUIRED = 'RSA_REQUIRED',
  SELF_EXCLUDED = 'SELF_EXCLUDED',
  SESSION_COOL_OFF = 'SESSION_COOL_OFF',
  SITE_MISMATCH = 'SITE_MISMATCH',
  TEMP_PIN_REQUIRED = 'TEMP_PIN_REQUIRED',
  TEMP_PIN_REQUIRED_SMS = 'TEMP_PIN_REQUIRED_SMS',
  TIME_LIMIT_REACHED = 'TIME_LIMIT_REACHED',
  TOTAL_LIMIT_REACHED = 'TOTAL_LIMIT_REACHED',
  TRANSFER_APC_NOT_READY = 'TRANSFER_APC_NOT_READY',
  UNKOWN_ERROR = 'UNKOWN_ERROR',
  USER_BANNED_BY_REGULATOR = 'USER_BANNED_BY_REGULATOR',
  USER_HAS_PENDING_CASHOUTS = 'USER_HAS_PENDING_CASHOUTS',
  USER_SELF_EXCUDED = 'USER_SELF_EXCLUDED',
  VALIDATION_ERROR = 'VALIDATION_ERROR'
}
